<div class="price_sources_order">
  <p class="order_hint">{{ 'settings.orders_settings.price_sources_order_hint' | translate }}</p>

  <div cdkDropList class="sources_list" (cdkDropListDropped)="drop($event)">
    <div class="source_row" *ngFor="let row of rows; trackBy: trackByKind" cdkDrag
         [class.disabled]="!row.used">
      <span class="drag_handle" cdkDragHandle aria-hidden="true">
        <ui-svg-icon svgIcon="grip-vertical" size="small"></ui-svg-icon>
      </span>

      <div class="source_info">
        <span class="source_title">{{ labelKey(row.kind) | translate }}</span>
        <p class="source_description">{{ descriptionKey(row.kind) | translate }}</p>
      </div>

      <!-- A freshness window only means something for an imported tariff or
           an order history — the two others never show the field, so no
           phantom value can survive in a control the eye cannot see. -->
      <div class="source_window" *ngIf="windowable(row.kind)">
        <label class="window_label" [attr.for]="'window_' + row.kind">
          {{ 'settings.orders_settings.freshness_window' | translate }}
        </label>
        <input
          class="window_input"
          [id]="'window_' + row.kind"
          type="number"
          min="1"
          [disabled]="!row.used"
          [value]="row.freshnessDays ?? ''"
          [placeholder]="'settings.orders_settings.freshness_window_none' | translate"
          (change)="setWindow(row, $any($event.target).value)" />
      </div>

      <mat-slide-toggle
        color="primary"
        [checked]="row.used"
        (change)="toggle(row, $event.checked)">
      </mat-slide-toggle>
    </div>
  </div>

  <!-- Stated, never offered: making expiry configurable would mean letting a
       tenant quote a price that has lapsed. -->
  <p class="expiry_rule">{{ 'settings.orders_settings.expired_price_rule' | translate }}</p>
</div>
